module.exports = __webpack_public_path__ + "static/media/video_preview.40d1e404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/video_preview.jpg
// module id = 1646
// module chunks = 0